var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "DashboardCardScaffold",
    {
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "flex items-center" },
                [
                  _c("HeartIcon", {
                    staticClass: "h-8 w-8 fill-current text-primary-500 mr-2",
                  }),
                  _c(
                    "RouterLink",
                    {
                      staticClass: "hover:text-primary-500",
                      attrs: {
                        to: {
                          name: _vm.routes.MY_FAVORITES,
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "font-semibold text-base" }, [
                        _vm._v("Favorites"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c("InvitationModalWithButton", {
                staticClass: "flex flex-grow justify-end",
                attrs: {
                  companyId: _vm.companyId,
                  currentUser: _vm.currentUser,
                  currentUserId: _vm.currentUserId,
                  companyBusinessName: _vm.companyBusinessName,
                  isManager: _vm.isManager,
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "CardItemScaffold",
        {
          staticClass: "mb-2",
          attrs: { itemNumber: _vm.total, itemTitle: "Resources" },
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return [
                  _c("HeartIcon", {
                    staticClass: "h-5 w-5 fill-current text-primary-500",
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("ItemChipsWithMore", {
            attrs: {
              items: _vm.contractorsInfo,
              routeName: _vm.routes.CONTRACTOR_DETAILS_ABOUT,
              navigateTo: { name: _vm.routes.MY_FAVORITES },
              maxChipWidth: "max-w-40",
              isPerson: "",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }